<script>

import WorkflowModalForm from './WorkflowModalForm'
import Workflow from './Workflow'
import WorkflowRunner from './WorkflowRunner'
import WorkflowProgress from './WorkflowProgress'

import SearchableList from './SearchableList'
import SearchBar from './SearchBar'
import BlankSlate from './BlankSlate'

import FileDownload from './FileDownload'
import {uniqBy, flatten} from 'lodash'

export default {

  mixins: [
    SearchableList,
    FileDownload
  ],

  components: {
    WorkflowModalForm,
    WorkflowProgress,
    SearchBar,
    BlankSlate
  },

  computed: {
    hasCheckedRows() {
      return this.checkedRows.length > 0
    }
  },

  data() {
    return {
      workflow: null,
      records: [],
      checkedRows: [],
      exportIsLoading: false,

      showWorkflowModal: false,

      workflowRunner: null
    }
  },

  mounted() {
    this.reload()
  },

  watch: {
    workflow() {
      this.showWorkflowModal = !!this.workflow
    },

    showWorkflowModal(valueIs, valueWas) {
      if (valueWas && !valueIs) {
        this.reload()
      }
    }
  },

  methods: {

    downloadSelectedWorkflows() {
      if (!this.hasCheckedRows) { return }
      this.exportIsLoading = true

      let actionTemplates = this.checkedRows.map((workflow)=>{
        return workflow.requiredTemplates()
      })
      actionTemplates = _.flatten(actionTemplates)
      actionTemplates = _.uniqBy(actionTemplates, 'uuid')

      let jsonExport = {
        workflows: this.checkedRows.map((workflow)=>{
          return workflow.asJson()
        }),
        action_templates: actionTemplates
      }

      let filename = `luna-export.json`
      this.download(filename, JSON.stringify(jsonExport))
      setTimeout(()=>{
        this.exportIsLoading = false
      }, 500)
    },

    run(workflow) {
      workflow.$once('complete', ()=>{
        workflow.$off('progress')
      })
      this.workflowRunner = new WorkflowRunner(workflow)
    },

    destroy(workflow) {
      if (!confirm('Really?')) { return }
      workflow.destroy()
      this.reload()
    },
    edit(workflow) {
      this.workflow = workflow
    },

    addWorkflow() {
      this.workflow = new Workflow({
        name: ""
      })
    },

    reload() {
      this.showWorkflowModal = false
      this.$nextTick(()=>{
        this.records = Workflow.storage.all()
      })
    }
  }
}
</script>

<template>
  <div>
    <workflow-progress v-if="workflowRunner" :workflowRunner="workflowRunner" @close="workflowRunner = null"></workflow-progress>
    <workflow-modal-form :workflow="workflow" :active.sync="showWorkflowModal" @reload="reload"></workflow-modal-form>

    <search-bar>
      <div class="buttons">
        <b-button icon-left="plus" @click="addWorkflow">Create new Workflow</b-button>
      </div>
    </search-bar>

    <b-table :data="filteredRecords" checkable :checked-rows.sync="checkedRows">
      <template slot-scope="props">
        <b-table-column field="name" label="Name">
          {{ props.row.name }}
        </b-table-column>

        <b-table-column field="tags" label="Tags">
          <b-taglist>
            <b-tag v-for="tag in props.row.tags" :key="`${props.row.uuid}-tag-${tag}`">
              {{ tag }}
            </b-tag>
          </b-taglist>
        </b-table-column>

        <b-table-column>
          <div class="buttons is-right">
            <b-button icon-left="cloud-upload-outline" size="is-small" @click="run(props.row)">
              Run
            </b-button>
            <b-button icon-left="square-edit-outline" size="is-small" @click="edit(props.row)">
              Edit
            </b-button>
            <b-button icon-left="trash-can-outline" size="is-small" type="is-danger" @click="destroy(props.row)">
              Delete
            </b-button>
          </div>
        </b-table-column>
      </template>

      <template slot="empty">
        <blank-slate @reload="reload" :isFiltered="!!searchQuery"></blank-slate>
      </template>
    </b-table>

    <div v-show="hasCheckedRows">
      <br>
      <b-button @click="downloadSelectedWorkflows" :disabled="exportIsLoading" :loading="exportIsLoading" type="is-primary" icon-left="code-braces">Export selection as JSON</b-button>
    </div>

  </div>
</template>

<style lang="scss" scoped>
table .buttons {
  opacity: 0.7;
}
table tr:hover .buttons {
  opacity: 1;
}
</style>